import React, { useState } from "react"
import { Box, Paper, Stack, Typography } from "@mui/material"
import CodeViewer from "../../../../components/CodeViewer/code-viewer"
import DynamicTextarea from "../../../../components/Input/DynamicTextarea"

const DynamicTextareaPage = () => {
    const [bio, setBio] = useState("")
    const [notes, setNotes] = useState("Texto inicial com múltiplas linhas\npara demonstrar o ajuste automático de altura.")
    const [observation, setObservation] = useState("")
    const codeBasicUsage = `import DynamicTextarea from "src/v2/components/Input/DynamicTextarea"

const [value, setValue] = useState("")

<DynamicTextarea
  label="Descrição"
  value={value}
  onChange={(event) => setValue(event.target.value)}
  minRows={2}
  maxRows={8}
/>`

    const codeCharacterCounter = `<DynamicTextarea
  label="Observação"
  value={value}
  onChange={(event) => setValue(event.target.value)}
  maxRows={6}
  characterLimit={300}
/>`

    const codePropsType = `type DynamicTextareaProps = {
  label: string
  value?: string | number
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  minRows?: number       // padrão 1
  maxRows?: number       // padrão 8
  disabled?: boolean
  readOnly?: boolean
  error?: boolean
  helperText?: string
  characterLimit?: number
  inputProps?: object  // props adicionais são repassadas ao textarea
}`

    return (
        <Box sx={{ width: "100%" }}>
            <Stack spacing={3}>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h4" gutterBottom color="common.white">
                            {`DynamicTextarea`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            {`Textarea que cresce conforme o conteúdo, com limites de linhas configuráveis. Mantém o estilo do design system e exibe label flutuante, estados de erro e desabilitado.`}
                        </Typography>

                        <Box mt={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Exemplo principal`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Altura automática até o limite definido. O valor é controlado via estado local.`}
                            </Typography>

                            <Box mt={2} sx={{ maxWidth: 620 }}>
                                <DynamicTextarea
                                    label="Sobre você"
                                    value={bio}
                                    onChange={(event) => setBio(event.target.value)}
                                    minRows={2}
                                    maxRows={8}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Paper>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            {`Estados comuns`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" paragraph>
                            {`Exemplos de uso com erro e desabilitado.`}
                        </Typography>

                        <Box sx={{ display: "grid", gap: 2, maxWidth: 700 }}>
                            <DynamicTextarea
                                label="Anotações"
                                value={notes}
                                onChange={(event) => setNotes(event.target.value)}
                            />

                            <DynamicTextarea
                                label="Com erro"
                                value={bio}
                                onChange={(event) => setBio(event.target.value)}
                                error
                                helperText="Campo obrigatório."
                            />

                            <DynamicTextarea
                                label="Desabilitado"
                                value="Conteúdo bloqueado para edição"
                                onChange={() => { }}
                                disabled
                            />
                        </Box>
                    </Box>
                </Paper>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            {`Variação com contador`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" paragraph>
                            {`Use characterLimit para exibir o limite dentro do campo.`}
                        </Typography>

                        <Box sx={{ maxWidth: 700 }}>
                            <DynamicTextarea
                                label="Observação"
                                value={observation}
                                onChange={(event) => setObservation(event.target.value)}
                                maxRows={6}
                                characterLimit={300}
                            />
                        </Box>

                        <Box mt={3}>
                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeCharacterCounter} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Box>
                </Paper>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            {`Uso básico`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" paragraph>
                            {`Configuração mínima para uso controlado e com limites de linhas.`}
                        </Typography>

                        <Paper variant="outlined">
                            <Box p={2}>
                                <CodeViewer code={codeBasicUsage} language="jsx" />
                            </Box>
                        </Paper>
                    </Box>
                </Paper>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            {`Propriedades do componente`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" paragraph>
                            {`Principais props expostas pelo DynamicTextarea. Props adicionais são repassadas ao elemento textarea.`}
                        </Typography>

                        <Paper variant="outlined">
                            <Box p={2}>
                                <Typography variant="subtitle2" gutterBottom color="common.white">
                                    {`Tipo das props (exemplo em TypeScript`}
                                    {`)`}
                                </Typography>
                                <CodeViewer code={codePropsType} language="tsx" />
                            </Box>
                        </Paper>
                    </Box>
                </Paper>

            </Stack>
        </Box>
    )
}

export default DynamicTextareaPage
